<template>
  <span class="font-weight-bold">{{ formattedValue }}</span>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String],
    },
    mediaMinima: {
      type: [Number],
      default: 7,
    },
    max: {
      type: Number,
      default: 80,
    },
    arredondamento: {
      type: Boolean,
      default: false,
    },
    tipoCampo: {
      type: String,
      default: "",
    },
    descricao: {
      type: String,
      default: "",
    },
  },
  watch: {
    value(val) {
      if (val > this.max) {
        this.$emit("change", parseFloat(this.max, 10));
      }
    },
  },
  created() {
    if (this.value > this.max) {
      this.$emit("change", parseFloat(this.max, 10));
    }
  },
  computed: {
    valueAsNumberOrNull() {
      return !this.valueIsEmpty ? parseFloat(this.value, 10) : null;
    },
    valueIsEmpty() {
      if (!this.value) {
        return "- - -";
      }
      // eslint-disable-next-line no-restricted-globals
      return this.value === null || this.value === undefined || isNaN(this.value);
    },
    formattedValue() {
      if (!this.value) return "- - -";
      let val = parseFloat(this.value);
      if (this.arredondamento) {
        val = this.roundValue(val);
      }

      if (this.descricao === "resultado" || this.descricao === "nota_anual") {
        return val <= this.max ? val.toFixed(1) : this.max.toFixed(1);
      }

      return val <= this.max ? Math.floor(val * 10) / 10 : this.max;
    },
  },
  methods: {
    roundValue(val) {
      const decimalPart = val % 1;
      if (decimalPart >= 0.1 && decimalPart < 0.3) {
        return Math.floor(val);
      }
      if (decimalPart >= 0.3 && decimalPart <= 0.7) {
        return Math.floor(val) + 0.5;
      }
      if (decimalPart > 0.7) {
        return Math.ceil(val);
      }
      return val;
    },
  },
};
</script>
